module.exports = __webpack_public_path__ + "static/media/play.77129028.svg";